import moment from "moment-timezone"
import { mapGameName } from "../../../constants/liveClass"
import {
  deleteLiveClass,
  startLiveClass,
  endLiveClass,
  scheduleLiveClass,
  updateLiveClass,
  getAvailableSchedulingTimeSlots,
  fetchLiveClassesAsCoach,
} from "../../../api/live-classes"

const state = {
  pendingClassesAsCoach: [],
  newLiveClass: null,
  availabilities: [],
  timeSlotsByDate: [],
  availableTime: {},
  availableDurations: [],
}
const getters = {
  pendingClassesAsCoach: state => state.pendingClassesAsCoach,
  newLiveClass: state => state.newLiveClass,
  availabilities: state => state.availabilities,
  timeSlotsByDate: state => state.timeSlotsByDate,
  availableTime: state => state.availableTime,
  availableDurations: state => state.availableDurations,
}
const mutations = {
  setPendingClassesAsCoach: (state, pendingClassesAsCoach) =>
    (state.pendingClassesAsCoach = pendingClassesAsCoach),

  setNewLiveClass: (state, newLiveClass) => (state.newLiveClass = newLiveClass),
  setAvailabilities: (state, availabilities) =>
    (state.availabilities = availabilities),
  setTimeSlotsByDate: (state, timeSlotsByDate) =>
    (state.timeSlotsByDate = timeSlotsByDate),
  setAvailableTime: (state, availableTime) =>
    (state.availableTime = availableTime),
  setAvailableDurations: (state, durations) =>
    (state.availableDurations = durations),
}
const actions = {
  async startLiveClass ({}, { instaProAccessToken, classId }) {
    await startLiveClass(instaProAccessToken, classId)
  },
  async endLiveClass ({}, { instaProAccessToken, classId }) {
    await endLiveClass(instaProAccessToken, classId)
  },
  async scheduleLiveClass ({ commit }, { instaProAccessToken, newClass }) {
    commit(
      "setNewLiveClass",
      await scheduleLiveClass(instaProAccessToken, newClass)
    )
  },
  async getAvailableSchedulingTimeSlots (
    { commit, dispatch },
    { instaProAccessToken, game, date, exclusion }
  ) {
    await commit(
      "setAvailabilities",
      await getAvailableSchedulingTimeSlots(
        instaProAccessToken,
        game,
        date,
        exclusion
      )
    )
    await dispatch("getTimeSlots", { date })
  },
  async getTimeSlots ({ commit, state, dispatch }, { date }) {
    let slots = []
    for (let availability of state.availabilities) {
      if (
        moment(availability.day).format("YYYY-MM-DD") ===
        moment(date).format("YYYY-MM-DD")
      ) {
        slots = availability.timeSlots
        break
      }
    }
    slots = slots.filter(slot => {
      return slot.durationOptions.length > 0
    })
    await commit("setTimeSlotsByDate", slots)
    dispatch("getAvailableTime")
  },
  async getAvailableTime ({ commit, state }) {
    const availableTime = {}
    for (let timeSlot of state.timeSlotsByDate) {
      const time = moment(timeSlot.startTime)
        .local()
        .format("H:mm")
      const timeArray = time.split(":")
      const hour = timeArray[0]
      const minute = timeArray[1]
      if (availableTime[hour]) availableTime[hour].push(minute)
      else availableTime[hour] = [minute]
      commit("setAvailableTime", availableTime)
    }
  },
  async getAvailableDurations ({ commit, state }, time) {
    let durations = []
    for (let slot of state.timeSlotsByDate) {
      if (
        moment
          .utc(slot.startTime)
          .local()
          .format("H:mm") === time
      ) {
        durations = slot.durationOptions
        break
      }
    }
    await commit("setAvailableDurations", durations)
  },

  async fetchPendingClassesAsCoach ({ commit }, instaProAccessToken) {
    const pendingClasses = await fetchLiveClassesAsCoach(
      instaProAccessToken,
      "PENDING",
      "OLDEST_FIRST"
    )
    for (let pendingClass of pendingClasses) {
      if (pendingClass.game) {
        pendingClass.game.name = mapGameName(pendingClass.game.name)
      } else {
        pendingClass.game = { name: mapGameName("") }
      }
    }
    commit("setPendingClassesAsCoach", pendingClasses)
  },
  async deleteLiveClass ({ dispatch }, { instaProAccessToken, classId }) {
    await deleteLiveClass(instaProAccessToken, classId)
    dispatch("fetchPendingClassesAsCoach", instaProAccessToken)
  },
  async updateLiveClass (
    { dispatch },
    { instaProAccessToken, id, updatedClass }
  ) {
    await updateLiveClass(instaProAccessToken, id, updatedClass)
    dispatch("fetchPendingClassesAsCoach", instaProAccessToken)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/live-classes/coaching.js